import { BrowserRouter } from 'react-router-dom'
import Redirect from 'react-https-redirect'

import { GlobalPopupStyle } from '@/componentsV1/BaseComponents/Popup'
import Router from '@/components/routes/Router'

import './styles/fonts.scss'
import { AnalyticsProvider } from '@/features/amplitude'
import { OpenFeatureProvider } from '@openfeature/react-sdk'
import { UsersnapProvider } from '@/components/UsersnapSurvey'
import { EvervaultProvider } from '@evervault/react'
import { TooltipProvider } from '@/ui'
import {
  OPEN_FEATURE_DOMAIN_NAME,
  useSetOpenFeatureTargetingKey,
} from '@/features/open-feature'
import { CheckoutStateProvider } from '@/features/user/signup/payment/context'
import { useBodyPointerEventsGuard } from '@/hooks/useBodyPointerEventsGuard'

const App = () => {
  useSetOpenFeatureTargetingKey()
  useBodyPointerEventsGuard()

  return (
    <div className="App" id="App">
      <EvervaultProvider
        teamId={process.env.VITE_EVERVAULT_TEAM_ID ?? ''}
        appId={process.env.VITE_EVERVAULT_APP_ID ?? ''}
      >
        <OpenFeatureProvider domain={OPEN_FEATURE_DOMAIN_NAME}>
          <AnalyticsProvider>
            <UsersnapProvider>
              <TooltipProvider>
                <CheckoutStateProvider>
                  <GlobalPopupStyle />
                  <Redirect disabled={process.env.NODE_ENV === 'development'}>
                    <BrowserRouter>
                      <Router />
                    </BrowserRouter>
                  </Redirect>
                </CheckoutStateProvider>
              </TooltipProvider>
            </UsersnapProvider>
          </AnalyticsProvider>
        </OpenFeatureProvider>
      </EvervaultProvider>
    </div>
  )
}

export default App
